import i18n from "@/i18n/i18n";
import { checkSelectorExists } from "@/init/onboarding/utils";
import scrollToElement from "@/utils/scrollToEl.js";

export const START_GRADING_SCENARIO_STEPS = {
  get classAssignmentSelect() {
    return {
      element: "[data-testid='submission-form-class-assignment']",
      popover: {
        title: i18n.t("onboarding.startGrading.classAssignment.title"),
        description: i18n.t(
          "onboarding.startGrading.classAssignment.description"
        ),
        side: "top",
        align: "center",
      },
    };
  },
  get rubricSelect() {
    return {
      element: "[data-testid='submission-form-rubric-select']",
      popover: {
        title: i18n.t("onboarding.startGrading.rubricSelect.title"),
        description: i18n.t("onboarding.startGrading.rubricSelect.description"),
        side: "top",
        align: "center",
      },
    };
  },
  get referenceMaterial() {
    return {
      element: "[data-testid='submission-form-reference-material']",
      popover: {
        title: i18n.t("onboarding.startGrading.referenceMaterial.title"),
        description: i18n.t(
          "onboarding.startGrading.referenceMaterial.description"
        ),
        side: "top",
        align: "center",
      },
    };
  },
  get uploadArea() {
    return {
      element: "[data-testid='submission-form-upload-area']",
      popover: {
        title: i18n.t("onboarding.startGrading.uploadArea.title"),
        description: i18n.t("onboarding.startGrading.uploadArea.description"),
        side: "left",
        align: "center",
      },
    };
  },
  get gradingDetails() {
    return {
      element: "[data-testid='grading-details-form']",
      popover: {
        title: i18n.t("onboarding.startGrading.gradingDetails.title"),
        description: i18n.t(
          "onboarding.startGrading.gradingDetails.description"
        ),
        side: "left",
        align: "center",
        onNextClick: async (element, step, options) => {
          try {
            const lastCardElement = document.querySelector(
              ".eg-card-item:last-of-type"
            );
            if (lastCardElement) {
              scrollToElement(lastCardElement);
            }
            document.querySelector(".additional-collapse-control")?.click();
            await checkSelectorExists(
              "[data-testid='grading-details-flexible-scoring'] .graded-status",
              { timeout: 100 }
            );
            options.driver.moveNext();
          } catch (error) {
            options.driver.moveNext();
          }
        },
      },
    };
  },
  get gradingDetailsFlexibleScoring() {
    return {
      element: "[data-testid='grading-details-flexible-scoring']",
      popover: {
        title: i18n.t("onboarding.startGrading.flexibleScoring.title"),
        description: i18n.t(
          "onboarding.startGrading.flexibleScoring.description"
        ),
        side: "top",
        align: "center",
      },
    };
  },
};

export default {
  get steps() {
    return [
      START_GRADING_SCENARIO_STEPS.classAssignmentSelect,
      START_GRADING_SCENARIO_STEPS.rubricSelect,
      START_GRADING_SCENARIO_STEPS.referenceMaterial,
      START_GRADING_SCENARIO_STEPS.uploadArea,
      START_GRADING_SCENARIO_STEPS.gradingDetails,
      START_GRADING_SCENARIO_STEPS.gradingDetailsFlexibleScoring,
    ];
  },
};
